<template>

  <!-- Rescheduled (RESCHEDULED) -->
  <order-list-data-table
      title="Rescheduled"
      defaultSortField="rescheduled_at"
      defaultSortOrder="dsc"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      :linkToLocations="true" />

</template>

<script>
import OrderListDataTable from '@/components/orders/OrderListDataTable'

export default {
  name: 'OrderListRescheduledPage',

  components: {
    OrderListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Order#', value: 'order_number' },
        // { text: 'Provider', value: 'provider_alias' },
        // { text: 'Account', value: 'thirdparty_account_name' },
        { text: 'Brand', width: '140px', value: 'thirdparty_brand_name' },
        { text: 'Total', value: 'order_details.total' },
        { text: 'From', value: 'shipper.name' },
        { text: 'To', value: 'receiver.name' },
        { text: 'Rescheduled', value: 'rescheduled_at', align: 'center' },
        { text: 'Status', value: 'order_status' }
      ],
      status: ['RESCHEDULED'],
      assocs: 'shipper,receiver,order_details,parent_order'
    }
  }
}
</script>

<style scoped>
</style>
